
import { HttpResponse } from "../auth/AuthInterface";

export const defaultServicio: ServicioProps = { idServicio: 0, codigoAcceso: '', numeroTurno: '' };

export interface ServicioProps {
    idServicio:         number;
    numeroTurno:        string;
    codigoAcceso:       string;
}

export interface AgregarServicioParams {
    idTipoServicio:     number;
    telefonoCelular:    string;
    atencionUrgente:    boolean;
}

export interface AgregarServicioResponse extends HttpResponse {
    idServicio:         number;
    numeroTurno:        string;
    codigoAcceso:       string;
}

export interface ImprimirTicketParams {    
    idServicio:         number;
}

export interface ValidarTelefonoCelularWhatsAppParams {    
    telefonoCelular:    string;
}

export interface ReenviarWhatsAppParams {    
    idServicio:         number;
}